import { render, staticRenderFns } from "./HighLight.vue?vue&type=template&id=34d0f3a8&scoped=true&"
import script from "./HighLight.vue?vue&type=script&lang=js&"
export * from "./HighLight.vue?vue&type=script&lang=js&"
import style0 from "./HighLight.vue?vue&type=style&index=0&id=34d0f3a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d0f3a8",
  null
  
)

export default component.exports